module.exports = __webpack_public_path__ + "media/images/stock_groups/ea77-369ecbab3f106a88353e21db29b75cfc.svg";